import { PreconfiguredMessageInterface } from '@rsos/reduxDataStore/src/features/alerts/chat.types';
import { postLocationShareRequestUrl } from '@rsos/utils/fetchPublicServices';

export const PRECONFIG_REQUEST_LOCATION = 'Request Location';

const DYNAMIC_TITLE_HANDLERS: Record<
  string,
  (args: Record<string, unknown>) => Promise<string>
> = {
  [PRECONFIG_REQUEST_LOCATION]: async ({
    callerID,
    token,
    orgName,
  }: {
    callerID?: string;
    token?: string;
    orgName?: string;
  }) => {
    return postLocationShareRequestUrl(callerID, orgName, token);
  },
};

const replacePlaceholders = (message: string, realValue: string) => {
  return message.replace(/\{\{.*?\}\}/g, realValue);
};

export const getMatchingPreconfigured = (
  preconfiguredMessages: PreconfiguredMessageInterface[],
  searchedMessage: string,
) => {
  return preconfiguredMessages.filter(preconfiguredMessage => {
    const lowerSearchedMessage = searchedMessage.toLowerCase();

    const isMatchingTitle = preconfiguredMessage.title
      .toLowerCase()
      .includes(lowerSearchedMessage);

    const isMatchingMessage = preconfiguredMessage.body
      .toLowerCase()
      .includes(lowerSearchedMessage);

    return isMatchingMessage || isMatchingTitle;
  });
};

interface HandleDynamicMessageInterface {
  preconfiguredMessage: PreconfiguredMessageInterface;
  callerID?: string;
  token?: string;
  orgName?: string;
}

export const handleDynamicMessage = async ({
  preconfiguredMessage,
  ...args
}: HandleDynamicMessageInterface & Record<string, any>) => {
  const handler = DYNAMIC_TITLE_HANDLERS[preconfiguredMessage.title];

  if (!handler) {
    return preconfiguredMessage;
  }

  const url = await handler({ ...args, preconfiguredMessage });
  const newBody = replacePlaceholders(preconfiguredMessage.body, url);
  console.log(newBody);
  return {
    ...preconfiguredMessage,
    body: newBody,
  };
};
